/*=========================================================================================
  File Name: moduleAuthActions.js
  Description: Auth Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vue Monica Refine Design
  Author: Riyan Kurniawan
  -- MONICA --
==========================================================================================*/

import firebase from 'firebase/app'
import 'firebase/auth'
import router from '@/router'
import AuthService from '../../repository/auth'

export default {
  loginAttempt({ dispatch }, payload) {
    //
    const newPayload = {
      loading: payload.loading,
      userDetails: payload.userDetails,
      notify: payload.notify,
      openOtp: payload.openOtp,
    }
    if (!payload.checkbox_remember_me) {
      // localStorage.setItem('remember_me', false);
      firebase
        .auth()
        .setPersistence(firebase.auth.Auth.Persistence.SESSION)
        .then(function () {
          //
          dispatch('login', newPayload)
        })
        .catch(function (err) {
          payload.notify.error(err.message)
        })
    } else {
      // localStorage.setItem('remember_me', true);
      dispatch('login', newPayload)
    }
  },
  reloadStorage({ commit, state }, payload) {
    localStorage.setItem('token', payload.token)
    localStorage.setItem('expired', payload.expired_date)
  },
  login({ commit, state, dispatch }, payload) {
    // if (state.isUserLoggedIn()) {
    //     payload.notify({
    //         title: 'Login Attempt',
    //         text: 'You are already logged in!',
    //         iconPack: 'feather',
    //         icon: 'icon-alert-circle',
    //         color: 'warning'
    //     });
    //     return false
    // }
    let form = {
      email: payload.userDetails.email,
      password: payload.userDetails.password,
    }
    AuthService.login(form).then(
      (result) => {
        //
        // (result);
        if (result.data.status == 'true') {
          //
          payload.loading('oke')

          const need_otp = result.data.data.status_otp
          if (need_otp == true) {
            payload.openOtp(true)
            let otpPayload = {
              email: payload.userDetails.email,
            }
            dispatch('sendOtp', {
              ...otpPayload,
              loading: payload.loading,
              notify: payload.notify,
            })
            return
          } else {
            AuthService.setStorageLogin(
              result.data.data.user_data[0],
              result.data.data.token,
              result.data.data.monthly_change
            )
            commit('UPDATE_AUTHENTICATED_USER', result.data.data.user_data[0])
            // localStorage
            router.push('/')
          }
          // let date = result.data.data.expired_date
          // localStorage.setItem('expired', date)
          // AuthService.setStorageLogin(
          //   result.data.data.user_data[0],
          //   result.data.data.token,
          //   result.data.data.monthly_change
          // )
          // commit('UPDATE_AUTHENTICATED_USER', result.data.data.user_data[0])
          // // localStorage
          // router.push('/')

          // send otp to email for verification

          // payload.openOtp(true)

          // let otpPayload = {
          //   email: payload.userDetails.email,
          // }

          // dispatch('sendOtp', {
          //   ...otpPayload,
          //   loading: payload.loading,
          //   notify: payload.notify,
          // })
        } else {
          //
          payload.loading('oke')
          payload.notify.error(result.data.error_msg, {
            timeout: 2000,
          })
        }
      },
      (err) => {
        payload.loading('oke')

        payload.notify.error(err.message, {
          timeout: 2000,
        })
      }
    )
  },
  sendOtp({ commit, state }, payload) {
    let form = {
      email: payload.email,
    }
    AuthService.sendOtp(form).then(
      (result) => {
        //
        // (result);
        if (result.data.status == 'true') {
          //
          payload.loading('oke')
          payload.notify.success(result.data.message, {
            timeout: 2000,
          })
          // router.push('/otp')
        } else {
          payload.loading('oke')
          payload.notify.error(result.data.error_msg, {
            timeout: 2000,
          })
        }
      },
      (err) => {
        payload.loading('oke')

        payload.notify.error(err.message, {
          timeout: 2000,
        })
      }
    )
  },
  checkOtp({ commit, state }, payload) {
    let form = {
      email: payload.email,
      password: payload.password,
      otp: payload.otp,
    }
    AuthService.checkOtp(form).then(
      (result) => {
        //
        // (result);
        if (result.data.status == 'true') {
          //
          AuthService.setStorageLogin(
            result.data.data.user_data[0],
            result.data.data.token,
            result.data.data.monthly_change
          )
          commit('UPDATE_AUTHENTICATED_USER', result.data.data.user_data[0])
          // localStorage
          router.push('/')
        } else {
          payload.loading('oke')
        }
      },
      (err) => {
        //
        payload.notify('not ok')
        payload.clearOtp('oke')
      }
    )
  },
  updateAuthenticatedUser({ commit }, payload) {
    commit('UPDATE_AUTHENTICATED_USER', payload)
  },
}
